/* unplugin-vue-components disabled */import { render } from "./QuickScaleRender.vue?vue&type=template&id=60700d62&scoped=true"
import script from "./QuickScaleRender.vue?vue&type=script&lang=js"
export * from "./QuickScaleRender.vue?vue&type=script&lang=js"

import "./QuickScaleRender.vue?vue&type=style&index=0&id=60700d62&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60700d62"]])

export default __exports__